import { useSelector } from "react-redux";
import {
  getCategoryError,
  getCategoryBreadcrumbs
} from "../../state/modules/category";
import {
  getTitle,
  getListOfBrands
} from "../../state/modules/brands/selectors";
import ErrorMessage from "../../components/ErrorMessage";
import BrandsPage from "../../components/BrandsPage";
import BrandsPageSkeleton from "../../components/BrandsPage/BrandsPageSkeleton";

const BrandsPageContainer = () => {
  const categoryError = useSelector(getCategoryError);
  const title = useSelector(getTitle);
  const groups = useSelector(getListOfBrands);
  const breadcrumbs = useSelector(getCategoryBreadcrumbs);

  if (categoryError) {
    return <ErrorMessage {...categoryError} />;
  }

  if (!groups || groups.length === 0) {
    return <BrandsPageSkeleton />;
  }

  return <BrandsPage title={title} groups={groups} breadcrumbs={breadcrumbs} />;
};

export default BrandsPageContainer;
